<template>
    <ai-form-text-box-dictionary
        ref="tbdRef"
        v-model:value="value"
        :field-name-text="meta.fieldNameText"
        :field-name-id="meta.fieldNameId"
        :title="meta.title"
        :data-source="tbds"
        :display-expr="meta.extParams.displayExpr"
        :value-expr="meta.extParams.valueExpr"
        :need-modified-class="false"
        @text-box-real-value-changed="tbExplRealValueChanged"
        @popupShown="popupShown"
    >
        <div class="flex h-full w-full flex-col gap-3">
            <pca-dictionary-grid-ro
                ref="gridRef"
                :meta="meta.extParams.gridRoMeta"
                :args="gridRoArgs"
                @dictionary-selection-changed="selectionChanged"
            />
        </div>
    </ai-form-text-box-dictionary>
</template>

<script setup>
import { computed, inject, ref } from 'vue';

import AiFormTextBoxDictionary from '@/components/card-component/ai-form-text-box-dictionary.vue';
import PcaDictionaryGridRo from '@/views/contracts/print-contract/components/pca-dictionary-grid-ro.vue';

const props = defineProps({
    meta: {
        type: Object,
        default: () => {},
    },
    callbacks: {
        type: Object,
        default: () => ({
            userDataChanged: null,
            dotsClick: () => {
                console.log('aiFormTextBoxVirtualGridDictionary, dotsClick');
            },
        }),
    },
});

const userData = inject('userData');
const tbdRef = ref(null);
const gridRef = ref(null);

const gridRoArgs = computed(() => {
    return props.meta.extParams.gridRoArgs;
});
const explFocusedRowKey = ref(null);

const popupShown = async () => {
    const request = generateRequest();

    if (gridRef.value) {
        await gridRef.value.gridRoRef.refreshData(request);
    }
};

const generateRequest = () => {
    const dataType = props.meta.dataType;

    const request = {};

    if (dataType === 'type_contract' || dataType === 'annexes') {
        return request;
    }

    if (dataType === 'objects') {
        return {
            contractID: getContractID(),
            date: getDatePrint(),
            statuses: '0,2',
        };
    }

    if (dataType === 'metering_points') {
        return {
            contractID: getContractID(),
            date: getDatePrint(),
            contractObjIDs: getObjects(),
            dateTUs: getDateTUFrom(),
            dateTUpo: getDateTUTo(),
            datePUs: getDatePUFrom(),
            datePUpo: getDatePUTo(),
            fl_PostR: getNeedPrintConstantConsumption(),
        };
    }
};

const getDatePrint = () => {
    return convertDateToString(userData.value['as_of_date']);
};

const convertDateToString = date => {
    // дата должна поступать в виде строки вида 2025-01-21T15:44:06.325Z, поэтому пробуем распарсить её в миллисекунды
    // и создать объект типа Date для удобства дальнейшей обработки
    const dateParsed = new Date(Date.parse(date));
    // получаем номер месяца (добавляется 1, т.к. Date.getMonth() возвращает значения от 0 до 11
    const numberMonth = dateParsed.getMonth() + 1;
    // преобразуем месяц в строку и добавляем '0' к номерам месяцев, состоящих из одного символа
    const strMonth = numberMonth > 9 ? String(numberMonth) : '0' + String(numberMonth);
    // возвращаем строку с датой печати (по состоянию на) в виде, который требуется на back-е
    return String(dateParsed.getDate()) + '.' + strMonth + '.' + String(dateParsed.getFullYear());
};

const getContractID = () => {
    // выделяем код договора (пока передаём на back код одного договора - первого в списке выбранных)
    return userData.value['list_contract_value'][0];
};

const getObjects = () => {
    return userData.value['list_object_value'];
};

const getDateTUFrom = () => {
    return convertDateToString(userData.value['metering_point_creation_date']);
};

const getDateTUTo = () => {
    return convertDateToString(userData.value['metering_point_deletion_date']);
};

const getDatePUFrom = () => {
    return convertDateToString(userData.value['electricity_meter_installation_date']);
};

const getDatePUTo = () => {
    return convertDateToString(userData.value['electricity_meter_removal_date']);
};

const getNeedPrintConstantConsumption = () => {
    return 1;
};

const value = computed({
    get: () => {
        if (userData.value[props.meta.fieldNameText] === undefined) {
            return null;
        }
        return userData.value[props.meta.fieldNameText];
    },
});

const userDataChange = () => {
    props.callbacks.userDataChanged();
};

const selectionChanged = async event => {
    const listText = [];
    const listId = [];

    for (let i = 0; i < event.length; i++) {
        listText.push(event[i][props.meta.extParams.displayExpr]);
        listId.push(event[i][props.meta.extParams.valueExpr]);
    }

    userData.value[props.meta.fieldNameText] = listText.join('; ');
    userData.value[props.meta.fieldNameId] = listId;

    userDataChange();

    explFocusedRowKey.value = event?.key;
    tbdRef.value?.popupInstance.hide();
};
const tbExplRealValueChanged = newValue => {
    explFocusedRowKey.value = newValue;
};
const tbds = computed(() => {
    return [
        {
            [`${props.meta.extParams.valueExpr}`]: userData.value[props.meta.fieldNameId],
            [`${props.meta.extParams.displayExpr}`]: userData.value[props.meta.fieldNameText],
        },
    ];
});
</script>
